import get from 'lodash/get';

export const isHighDemandIconShow = ({ option, placingTermsApi }) => {
  const selectedOption = get(placingTermsApi, 'selected.option', {});
  const isHighDemand = get(placingTermsApi, 'terms.isHighDemand', false);

  const isOptionFreeOrPaid = ['free', 'paid'].includes(selectedOption.id);

  // Спрос повышен в текущем районе
  return isHighDemand &&
    // текущий VAS выбран
    option.id === selectedOption.id &&
    // выбранный VAS не «Бесплатно» и не «Платное»
    !isOptionFreeOrPaid;
};
